import { render, staticRenderFns } from "./ContactUsPage.vue?vue&type=template&id=50b094dc&scoped=true&"
import script from "./ContactUsPage.vue?vue&type=script&lang=js&"
export * from "./ContactUsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsPage.vue?vue&type=style&index=0&id=50b094dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b094dc",
  null
  
)

export default component.exports